export const COLORS = {
  WHITE: 'white',
  TOY_RED: '#E73439',
  SPACE_BLUE: '#181C23',
  PIRATES_RED: '#BF0721',
  PIRATES_RED_DARK: '#900B22',
  PIRATES_RED_LIGHT: '#FC646A',
  PIRATES_RED_LIGHTER: '#FF9FA2',
  POLAR_GREEN: '#0FAF27',
  POLAR_GREEN_DARK: '#085814',
  POLAR_GREEN_LIGHT: '#5ED583',
  POLAR_GREEN_LIGHTER: '#8CF2AB',
  APOLLO_ORANGE: '#E88000',
  APOLLO_ORANGE_DARK: '#A85C0F',
  APOLLO_ORANGE_LIGHT: '#FD9D27',
  APOLLO_ORANGE_LIGHTER: '#FFBD6C',
  RIVER_BLUE: '#2E98D9',
  RIVER_BLUE_DARK: '#1B4B69',
  RIVER_BLUE_LIGHT: '#48B8FD',
  RIVER_BLUE_LIGHTER: '#9AD8FF',
  IRIS_PURPLE: '#9E6BD8',
  IRIS_PURPLE_DARK: '#533A6F',
  IRIS_PURPLE_LIGHT: '#C294F5',
  IRIS_PURPLE_LIGHTER: '#DDC2FC',
  JADE_GRAY: '#D7DBE0',
  SMOKE_GRAY: '#B5B9C3',
  SHARK_GRAY: '#A3A8AF',
  SURFACE_GRAY: '#83899B',
  ONYX_GRAY: '#3B4050',
  GRAY_100: '#f2f2f5', // waiting name from design
  GRAY_200: '#e4e4ed', // waiting name from design
  TITAN_WHITE: '#E5F0FC',
}
